import { SET_VIEW, CurrentMapViewTypes } from "./mapSwitcher.Actions";

const initialState = { currentView: "campusmap", usedSwitcher: false };

const MapSwitcherReducer = (
  state = initialState,
  action: CurrentMapViewTypes
) => {
  switch (action.type) {
    case SET_VIEW:
      return {
        currentView: action.payload.currentView,
        usedSwitcher: action.payload.usedSwitcher,
      };
    default:
      return state;
  }
};

export default MapSwitcherReducer;
